/**
 * Permissions that grant read access to the badge module's settings collection
 * (GET kiosk-settings / printer-settings - both hit PrinterSettingsController@getAllSettings).
 * Either one is enough, and the API route accepts both: badge printing reads
 * enable_momentive_print_service (which print provider to mount) and the sync_* keys (which
 * attendees are printable) out of that same payload, so a user who can print badges needs to
 * read it even when they cannot open check-in setup. Write access stays on
 * badges.check_in_setup.edit alone.
 */
export const BADGE_SETTINGS_READ_PERMISSIONS = [
  'badges.check_in_setup.view',
  'badges_admin.badge_printing.view'
]

/**
 * Whether the current user may read badge settings. Guards the badges/getSettings dispatch so
 * a user with neither permission does not fire a request the API will refuse.
 *
 * Takes the component's $hasPermission rather than importing the checker directly, so call
 * sites stay mockable the way the rest of the app's permission gates are (tests/template.ts
 * mocks $hasPermission). Spelled out as a some() rather than handing $hasPermission the array,
 * because it requires every permission in an array and this check is an either/or.
 */
export function canReadBadgeSettings (hasPermission: (key: string) => boolean): boolean {
  return BADGE_SETTINGS_READ_PERMISSIONS.some(permission => hasPermission(permission))
}
